module.exports = __webpack_public_path__ + "static/media/ClinicaSantaIsabel.933979d6.svg";